export { default } from './TrialOfferView';



// WEBPACK FOOTER //
// ./src/components/views/TrialOfferView/index.js